import React, { useEffect, useState } from "react";

import WarningIcon from "@mui/icons-material/Warning";
import { Box, Button, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import Dialog from "@/components/Dialog";
import Padding from "@/components/layout/Padding";
import { colors } from "@/theme/overrides/colors";

interface Props {
  message: string;
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles()({
  paper: {
    minWidth: 400,
    maxWidth: 400,
  },
  content: {
    paddingTop: 0,
  },
  icon: {
    maxHeight: 60,
    fontSize: 60,
    color: colors.secondary,
  },
  title: {
    fontWeight: 700,
    fontSize: 28,
    lineHeight: 1,
    color: colors.dark,
    textAlign: "center",
  },
  message: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: "22px",
    color: colors.gray,
    textAlign: "center",
  },
  button: {
    minWidth: 125,
  },
});

const AttachmentErrDialogSize: React.FC<Props> = ({
  open,
  onClose,
  message,
}) => {
  const { classes } = useStyles();

  // When hiding the dialog, we set `sendMessageFailure` in redux store to null.
  // This will make the dialog display an empty string as message while fading
  // out. We will put message in a state to prevent this.
  const [msg, setMsg] = useState(message);
  useEffect(() => {
    if (message !== "") setMsg(message);
  }, [message]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.paper }}
      contentClassName={classes.content}
      content={
        <Box display="flex" margin="8px" alignItems="center">
          <Box display="flex" margin={9} alignItems="center">
            <div className={classes.icon}>
              <WarningIcon fontSize="inherit" color="inherit" />
            </div>
            <Typography className={classes.title}>
              File size is too large
            </Typography>
          </Box>
          <Padding horizontal={4}>
            <Typography className={classes.message}>{msg}</Typography>
          </Padding>
        </Box>
      }
      actions={
        <Button size="large" className={classes.button} onClick={onClose}>
          OK
        </Button>
      }
    />
  );
};

export default AttachmentErrDialogSize;
